export const commentsKeys = {
  allByHash: sampleHash => ["fetchCommentsList", sampleHash]
};
export const GET_LOCAL_SAMPLE_DETAILS = "getLocalSampleDetails";

export const sampleReportKeys = {
  mergedReportKey: (hash, isNetworkReport = false) => [
    "rlcsMergeReport",
    hash,
    isNetworkReport
  ],
  singleReportKey: (hash, reportId, isNetworkReport = false) => [
    "rlcsSingleReport",
    hash,
    reportId,
    isNetworkReport
  ],
  mergedURLReportKey: url => ["rlcsMergedReportURL", url],
  analysisStatus: hash => ["rlcsAnalysisStatus", hash],
  uriStatsByUrl: url => ["uriStats", url],
  visualization: (hash, sourceId) => ["visualization", hash, sourceId],
  expandedDetailsCloud: hash => ["expandedDetailsCloud", hash],
  downloadScreenshots: (hash, analysisId, isNetworkReport = false) => [
    "downloadScreenshots",
    hash,
    analysisId,
    isNetworkReport
  ],
  fetchExtractedScreenshots: (hash, analysisId, isNetworkReport = false) => [
    "fetchExtractedScreenshots",
    hash,
    analysisId,
    isNetworkReport
  ],
  downloadPcaps: (hash, analysisId, isNetworkReport = false) => [
    "downloadPcaps",
    hash,
    analysisId,
    isNetworkReport
  ],
  downloadDroppedFiles: (hash, analysisId, isNetworkReport = false) => [
    "downloadDroppedFiles",
    hash,
    analysisId,
    isNetworkReport
  ],
  downloadMemstrings: (hash, analysisId, isNetworkReport = false) => [
    "downloadMemstrings",
    hash,
    analysisId,
    isNetworkReport
  ],
  rlSandboxResourcesStatus: (hash, analysisId, isNetworkReport = false) => [
    "rlSandboxResourcesStatus",
    hash,
    analysisId,
    isNetworkReport
  ],
  historyRowStatus: analysisId => ["historyRowStatus", analysisId],
  droppedFilesToStaticAnalysis: (hash, analysisId) => [
    "droppedFilesToStaticAnalysis",
    hash,
    analysisId
  ],
  droppedFilesStaticAnalysisStatus: analysisId => [
    "droppedFilesStaticAnalysisStatus",
    analysisId
  ],
  resubmitAnalysis: (analysis, hash) => ["resubmit", analysis, hash],
  analysisCount: endpoint => ["analysis count", endpoint],
  generalInfo: (hash, analysis) => ["general info", analysis, hash],
  networkCounts: (hash, analysis, endpoint) => [
    "network count",
    hash,
    analysis,
    endpoint
  ],
  domainCounts: (hash, analysis, endpoint) => [
    "domain count",
    hash,
    analysis,
    endpoint
  ],
  behaviorCounts: (hash, analysis, endpoint) => [
    "behavior count",
    hash,
    analysis,
    endpoint
  ],
  networkData: endpoint => ["network data", endpoint],
  domainData: endpoint => ["domain data", endpoint],
  behaviorData: endpoint => ["behavior data", endpoint],
  malwareData: endpoint => ["malware data", endpoint],
  mutexData: endpoint => ["mutex data", endpoint],
  processDetails: endpoint => ["process details", endpoint],
  processTree: endpoint => ["process tree", endpoint],
  joeProcessTree: hash => ["joe process tree", hash],
  getBehaviorGraph: (hash, analysis) => ["get behavior graph", hash, analysis],
  getLocalSampleDetails: (
    hash,
    sourceId,
    relationshipId,
    droppedSourceId,
    parentHash
  ) => [
    GET_LOCAL_SAMPLE_DETAILS,
    hash,
    sourceId,
    relationshipId,
    droppedSourceId,
    parentHash
  ],
  getYaraStringMatches: (hash, yaraTestRunResultId) => [
    "yaraStringMatches",
    hash,
    yaraTestRunResultId
  ],
  getHexPreviewData: (sha1, searchAddress, previewType, beautify) => [
    "hexPreviewData",
    sha1,
    searchAddress,
    previewType,
    beautify
  ],
  getTextPreviewData: (sha1, previewType, beautify) => [
    "textPreviewData",
    sha1,
    previewType,
    beautify
  ],
  getImagePreviewThumbnail: sha1 => ["imagePreviewThumbnail", sha1],
  getInteractiveSessionParamsForHash: hash => [
    "getInteractiveSessionParamsForHash",
    hash
  ],
  getInteractiveSessionParamsForAnalysis: params => [
    "getInteractiveSessionParamsForHash",
    params?.hash,
    params?.analysisId
  ],
  getInteractiveSessionParamsForUploadId: uploadId => [
    "getInteractiveSessionParamsForUploadId",
    uploadId
  ]
};

export const FETCH_LOCAL_DATA = "fetchLocalData";
export const FETCH_CLOUD_DATA = "fetchCloudData";
export const FETCH_USER_LIST = "fetchUserList";
export const FETCH_NETWORK_DATA = "fetchLocalNetworkData";

export const advancedSearchKeys = {
  categories: timerange => ["uploadCategories"],
  checkAccess: ["checkAccess"],
  fetchLocalDataKey: params => [FETCH_LOCAL_DATA, { ...params }],
  fetchCloudDataKey: params => [FETCH_CLOUD_DATA, { ...params }],
  fetchNetworkDataKey: params => [FETCH_NETWORK_DATA, { ...params }],
  fetchCount: params => ["getCountData", { ...params }],
  reanalyzeSampleStatusKey: (page, pageSize) => [
    "reanalyzeSampleStatus",
    page,
    pageSize
  ],
  fetchBulk: ["bulkSearch"],
  toggleDateDisplay: ["toggleDateDisplay"],
  fetchUserData: ["fetchUserData"],
  fetchUserList: params => [FETCH_USER_LIST, { ...params }]
};

export const localSampleDetailsQueryKey = (
  sha1,
  sampleSourceId,
  relationshipId
) => ["expandedDetailsLocal", sha1, sampleSourceId, relationshipId];

export const networkKeys = {
  urlReport: url => ["urlThreatIntelligenceReport", url],
  domainReport: domain => ["domainThreatIntelligenceReport", domain],
  ipReport: ip => ["ipThreatIntelligenceReport", ip],
  whoIsReport: url => ["whoIsReport", url],
  dnsReport: url => ["dnsReport", url],
  bgpReport: ip => ["bgpReport", ip]
};

export const getTiCardDataKey = threatName => ["ticard_data", threatName];
